import { render } from "./EditCustomField.vue?vue&type=template&id=9f2c1100&scoped=true"
import script from "./EditCustomField.vue?vue&type=script&lang=js"
export * from "./EditCustomField.vue?vue&type=script&lang=js"

import "./customField.scss?vue&type=style&index=0&id=9f2c1100&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f2c1100"]])

export default __exports__